// @ts-nocheck
// addition of reimbursement category
export const ADD_REIMBURSEMENT_AND_DEDUCTION_CATEGORY_REQUEST =
  "ADD_REIMBURSEMENT_AND_DEDUCTION_CATEGORY_REQUEST";
export const ADD_REIMBURSEMENT_AND_DEDUCTION_CATEGORY_SUCCESS =
  "ADD_REIMBURSEMENT_AND_DEDUCTION_CATEGORY_SUCCESS";
export const ADD_REIMBURSEMENT_AND_DEDUCTION_CATEGORY_FAILURE =
  "ADD_REIMBURSEMENT_AND_DEDUCTION_CATEGORY_FAILURE";

// get reimbursement  category
export const GET_REIMBURSEMENT_CATEGORY_REQUEST =
  "GET_REIMBURSEMENT_CATEGORY_REQUEST";
export const GET_REIMBURSEMENT_CATEGORY_SUCCESS =
  "GET_REIMBURSEMENT_CATEGORY_SUCCESS";
export const GET_REIMBURSEMENT_CATEGORY_FAILURE =
  "GET_REIMBURSEMENT_CATEGORY_FAILURE";

// get deduction  category
export const GET_DEDUCTION_CATEGORY_REQUEST = "GET_DEDUCTION_CATEGORY_REQUEST";
export const GET_DEDUCTION_CATEGORY_SUCCESS = "GET_DEDUCTION_CATEGORY_SUCCESS";
export const GET_DEDUCTION_CATEGORY_FAILURE = "GET_DEDUCTION_CATEGORY_FAILURE";

// get deduction  category
export const GET_NON_TAXABLE_CATEGORY_REQUEST =
  "GET_NON_TAXABLE_CATEGORY_REQUEST";
export const GET_NON_TAXABLE_CATEGORY_SUCCESS =
  "GET_NON_TAXABLE_CATEGORY_SUCCESS";
export const GET_NON_TAXABLE_CATEGORY_FAILURE =
  "GET_NON_TAXABLE_CATEGORY_FAILURE";

// remove reimbursement or deduction cateogy
export const REMOVE_REIMBURSEMENT_AND_DEDUCTION_CATEGORY_REQUEST =
  "REMOVE_REIMBURSEMENT_AND_DEDUCTION_CATEGORY_REQUEST";
export const REMOVE_REIMBURSEMENT_AND_DEDUCTION_CATEGORY_SUCCESS =
  "REMOVE_REIMBURSEMENT_AND_DEDUCTION_CATEGORY_SUCCESS";
export const REMOVE_REIMBURSEMENT_AND_DEDUCTION_CATEGORY_FAILURE =
  "REMOVE_REIMBURSEMENT_AND_DEDUCTION_CATEGORY_FAILURE";

// get deduction amount of event
export const GET_DEDUCTION_AMOUNT_REQUEST = "GET_DEDUCTION_AMOUNT_REQUEST";
export const GET_DEDUCTION_AMOUNT_SUCCESS = "GET_DEDUCTION_AMOUNT_SUCCESS";
export const GET_DEDUCTION_AMOUNT_FAILURE = "GET_DEDUCTION_AMOUNT_FAILURE";

// add non taxable
export const ADD_NON_TAXABLE_REQUEST = "ADD_NON_TAXABLE_REQUEST";
export const ADD_NON_TAXABLE_SUCCESS = "ADD_NON_TAXABLE_SUCCESS";
export const ADD_NON_TAXABLE_FAILURE = "ADD_NON_TAXABLE_FAILURE";

// add deduction
export const ADD_DEDUCTION_REQUEST = "ADD_DEDUCTION_REQUEST";
export const ADD_DEDUCTION_SUCCESS = "ADD_DEDUCTION_SUCCESS";
export const ADD_DEDUCTION_FAILURE = "ADD_DEDUCTION_FAILURE";

// add reimbursement
export const ADD_REIMBURSEMENT_REQUEST = "ADD_REIMBURSEMENT_REQUEST";
export const ADD_REIMBURSEMENT_SUCCESS = "ADD_REIMBURSEMENT_SUCCESS";
export const ADD_REIMBURSEMENT_FAILURE = "ADD_REIMBURSEMENT_FAILURE";

// get all reimbursement of event action
export const GET_ALL_REIM_AND_DEDUC_OF_EVENT_REQUEST =
  "GET_ALL_REIM_AND_DEDUC_OF_EVENT_REQUEST";
export const GET_ALL_REIM_AND_DEDUC_OF_EVENT_SUCCESS =
  "GET_ALL_REIM_AND_DEDUC_OF_EVENT_SUCCESS";
export const GET_ALL_REIM_AND_DEDUC_OF_EVENT_FAILURE =
  "GET_ALL_REIM_AND_DEDUC_OF_EVENT_FAILURE";

// remove reimbursement or deduction
export const REMOVE_REIMBURSEMENT_OR_DEDUCTION_REQUEST =
  "REMOVE_REIMBURSEMENT_OR_DEDUCTION_REQUEST";
export const REMOVE_REIMBURSEMENT_OR_DEDUCTION_SUCCESS =
  "REMOVE_REIMBURSEMENT_OR_DEDUCTION_SUCCESS";
export const REMOVE_REIMBURSEMENT_OR_DEDUCTION_FAILURE =
  "REMOVE_REIMBURSEMENT_OR_DEDUCTION_FAILURE";

// add reimbursement by contractor
export const ADD_REIMBURSEMENT_CONT_REQUEST = "ADD_REIMBURSEMENT_CONT_REQUEST";
export const ADD_REIMBURSEMENT_CONT_SUCCESS = "ADD_REIMBURSEMENT_CONT_SUCCESS";
export const ADD_REIMBURSEMENT_CONT_FAILURE = "ADD_REIMBURSEMENT_CONT_FAILURE";

// update reimbursement and deduction
export const UPDATE_REIMB_AND_DEDUCT_REQUEST =
  "UPDATE_REIMB_AND_DEDUCT_REQUEST";
export const UPDATE_REIMB_AND_DEDUCT_SUCCESS =
  "UPDATE_REIMB_AND_DEDUCT_SUCCESS";
export const UPDATE_REIMB_AND_DEDUCT_FAILURE =
  "UPDATE_REIMB_AND_DEDUCT_FAILURE";

// NOTE: for event wrapper (right click)
export const OPEN_REIMBURSEMENT_MODAL = "OPEN_REIMBURSEMENT_MODAL";
export const OPEN_DEDUCTION_MODAL = "OPEN_DEDUCTION_MODAL";
export const OPEN_NON_TAXABLE_MODAL = "OPEN_NON_TAXABLE_MODAL";

export const CLOSE_REIMBURSEMENT_MODAL = "CLOSE_REIMBURSEMENT_MODAL";
export const CLOSE_DEDUCTION_MODAL = "CLOSE_DEDUCTION_MODAL";
export const CLOSE_NON_TAXABLE_MODAL = "CLOSE_NON_TAXABLE_MODAL";